
























































import Vue from "vue";

export default Vue.extend({
  name: "Topbar",
  props: ["activeTab"],
  methods: {},
  computed: {
    sidebarItems() {
      if (this.$store.state.activeOrg.role == "admin") {
        return [
          { id: "recent", title: "Recent", icon: "clock" },
          { id: "my-legos", title: "Mine", icon: "user" },
          { id: "all-org", title: "Org", icon: "users" },
          { id: "hidden", title: "Hidden", icon: "eye-slash" },
          // { id: "unpublished", title: "Unpublished Chains" },
        ];
      } else {
        return [
          { id: "recent", title: "Recent", icon: "clock" },
          { id: "my-legos", title: "Mine", icon: "user" },
          // { id: "unpublished", title: "Unpublished Chains" },
        ];
      }
    },
    isAdmin(): boolean {
      return this.$store.state.activeOrg.role == "admin";
    },
  },
});
